  
<!--降雨实况-->
<template>
    <div class="hdsq">
        <div class="control">
            <!-- <el-date-picker
                v-model="times[0]"
                value-format="yyyy-MM-dd HH:00" format="yyyy-MM-dd HH:00" 
                type="datetime"
                style="width:150px; margin-bottom:5px;"
                placeholder="开始时间">
            </el-date-picker>
            <el-date-picker
                v-model="times[1]"
                style="width:150px; margin-bottom:5px;"
                value-format="yyyy-MM-dd HH:00" format="yyyy-MM-dd HH:00" 
                type="datetime"
                placeholder="结束时间">
            </el-date-picker> -->
            <el-select v-model="selecttype" value-key="label"  style="width:110px;">
              <el-option 
                v-for="item in optionType" 
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-cascader
              :options="areaOptions"
              :props='defaultProps'
              v-model="area"
              placeholder="请选择区域"
              change-on-select
              style="width: 120px;"
            ></el-cascader>
            <el-input placeholder="请输入河道站名称或地址" v-model="riverName" style="width:190px" v-show="selecttype==3"></el-input>
            <el-button type="primary" @click="riverRvsr" icon="el-icon-search" ></el-button>
            <!-- <el-button type="primary" @click="excelRiver" >导出</el-button> -->
        </div>      
        <h3>河道水情表</h3>
        <el-table
          :data="riverRvsrData"
          style="width: 100%"
          :height="height-10"
          class="rvsrDetailTable">
          <el-table-column type="index"  align="center"> </el-table-column>
          <el-table-column prop="STNM" label="站名" align="center" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="TM" label="时间" align="center" width="100" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="Z" label="水位(m)" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                    <span v-if="scope.row.WPTN==5">{{scope.row.Z}} <img src="@/assets/images/zup.png"/></span>
                    <span v-else-if="scope.row.WPTN==4">{{scope.row.Z}} <img src="@/assets/images/jdown.png" /></span>
                    <span v-else>{{scope.row.Z}} <img src="@/assets/images/ping.png"/></span>
                </template>
            </el-table-column>
          <el-table-column prop="BJJ" label="比警戒(m)" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.BJJ>0" style="color: red">{{scope.row.BJJ}}</span>
                    <span v-else>{{scope.row.BJJ}}</span>
                </template>
          </el-table-column>
          <!-- <el-table-column prop="WRZ" label="警戒水位(m)"  align="center" width="100"  show-overflow-tooltip> </el-table-column>
          <el-table-column prop="Q" label="流量(m³/s)"  align="center" width="100"  show-overflow-tooltip> </el-table-column>
          <el-table-column prop="DRNA" label="集水面积(km²)"  align="center" width="120"  show-overflow-tooltip> </el-table-column>
          <el-table-column prop="HNNM" label="水系"  align="center" width="80"  show-overflow-tooltip> </el-table-column>
          <el-table-column prop="RVNM" label="河流名字"  align="center" width="140"  show-overflow-tooltip> </el-table-column>
          <el-table-column prop="OBHTZ" label="历史最高水位(m)" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="OBHTZTM" label="最高水位发生时间" align="center" show-overflow-tooltip></el-table-column> -->
        </el-table>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="currentTotal">
        </el-pagination> -->
    </div>
</template>
<script>
import $ from "jquery";
import eChartsPlug from "@/assets/util/echartsPlug.js";
let moment = require("moment");
const alladcd = require('./hnqx.json')
export default {
  name: "hdsq",
  data() {
    return {
      height:0,
      width:0,
      areaOptions: alladcd,
      defaultProps: {
        children: 'children',
        label: 'adnm',
        value:'adcd'
      },
      area:['430000'],
      riverRvsrData:[],
      riverName:'',
      adcd2:'430000',
      selecttype:1,
      dataAll:[],//所有数据
      dataS:[],//控制站数据
      times: [
        moment(new Date()).format("YYYY-MM-DD 00:00"),
        moment(new Date()).format("YYYY-MM-DD HH:mm")
      ],
      optionType:[
        {value:1,label:'控制站'},
        {value:2,label:'所有站'},
        {value:3, label:'自定义'},
      ],
      currentPage: 1,
      pageSize: 20,
      currentTotal: 0,
      options:window.HTCFG.AD,
    };
  },
  watch:{
    'selecttype':function(){
      console.log('selecttype',this.selecttype)
        if(this.selecttype==1){
          this.riverName='';
          this.riverRvsrData=this.dataS;
          this.currentTotal=this.riverRvsrData.length;
          // this.setColgroup();
        }else if(this.selecttype==2){
          this.riverName='';
          this.riverRvsrData=this.dataAll;
          this.currentTotal=this.riverRvsrData.length;
          // this.setColgroup();
          console.log('this.dataAll', this.dataAll)
        }else{
          this.riverRvsrData=[];
        }
    },
  },  
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    datevalue2(){
        return [
              moment(new Date()).format("YYYY-MM-DD 08:00"),
              moment(new Date()).format("YYYY-MM-DD HH:mm")
        ]
    },
    //自定义滚动
    setColgroup(){
      let thatVue=this;
      setTimeout(function() {
        $(".rvsrDetailTable").find("[name='gutter'],.gutter").remove();
        let tempTable=$(".rvsrDetailTable").find("table");
        tempTable.eq(0).width("100%");
        tempTable.eq(1).width("100%");  
        let scrollbar=$(".rvsrDetailTable").find(".el-table__body-wrapper");
        let scrollbarH=scrollbar.parent().height()-60;
        scrollbar.height(scrollbarH).niceScroll({
                cursorcolor: "#3380f3", // 改变滚动条颜色，使用16进制颜色值
                cursorwidth: "5px", // 滚动条的宽度，单位：便素
                cursorborderradius: "5px", // 滚动条圆角（像素）
                cursorborder: "1px solid rgba(144,147,153,.65)", // CSS方式定义滚动条边框
                background: "rgba(144,147,153,.5)", //轨道背景
                autohidemode: "leave",
                hidecursordelay: 400, // 设置滚动条淡出的延迟时间（毫秒）
                nativeparentscrolling: true, // 检测内容底部便于让父级滚动
                smoothscroll: true, // ease动画滚动
                sensitiverail: true, // 单击轨道产生滚动
                railpadding: { top: 0, right: 1, left: 1, bottom: 0 }, // 设置轨道的内间距
                horizrailenabled:false//水平滚动
           });      
      }, 500); 
    },
    //去除政区编码尾部的0--1
    del0(str){
      str=str+"";
      if(str==""){
        return str;
      }
      let temp=str;
      for(let len=str.length,i=len-1;i>=0;i--){
        if(str.slice(i)-0!=0){
          temp=str.slice(0,i+1);
          break;
        }
      }
      if(temp == "431"){
        temp = "4310";
      }
      return temp;
    },
    async riverRvsr(){
      this.adcd2=this.del0(this.area[this.area.length-1]);
      this.$http.get(window.HTCFG.apiUrl +"api/core/river/rsvr/"+this.times[0]+"/"+this.times[1]+'/'+this.adcd2+'/'+this.riverName).then(res => {
          var data=res.data || res.body;
          if(!this.riverName){
            this.dataAll=[];
            this.dataS=[];
            for(var i=0;i<data.length;i++){
                data[i].STNM = data[i].STNM.trim();
                data[i].TM=moment(data[i].TM).format('MM-DD HH:mm');
                if(data[i].OBHTZTM!=null){
                  data[i].OBHTZTM=moment(data[i].OBHTZTM).format('YYYY-MM-DD HH:mm');
                }
              if(data[i].FRGRD=="1"){
                  this.dataS.push(data[i]);
              }
              this.dataAll.push(data[i]);
            }
            if(this.selecttype==1){
                this.riverRvsrData=this.dataS;
                this.currentTotal=this.riverRvsrData.length;
                // this.setColgroup();
            }else{
                this.riverRvsrData=this.dataAll
                this.currentTotal=this.riverRvsrData.length;
                // this.setColgroup();
            }  
          }else{
            for(let i=0;i<data.length;i++){
               data[i].STNM = data[i].STNM.trim();
               data[i].TM=moment(data[i].TM).format('YYYY-MM-DD HH:mm');
            }
            this.riverRvsrData=data;
            this.currentTotal=this.riverRvsrData.length;
            // this.setColgroup()
          }  
      })
    },
    excelRiver(){
       this.$http.get(window.HTCFG.apiUrl +"api/core/excelRiver/"+this.selecttype+"/"+this.times[0]+"/"+this.times[1]+'/'+this.adcd2+'/'+this.riverName).then(res => {
         window.location.href = res.url;
      })
    }
  },
  mounted() {
    // $(".hdsq").height(window.innerHeight-140-35-20);
    $(".hdsq").height(window.innerHeight-100);
    var w=$(".hdsq").width();
    this.height=$(".hdsq").height();
    this.width=w;
    this.riverRvsr()
  }
};
</script>
<style scoped lang='less'>
  .hdsq{
    width:100%;
    .control{
      margin-bottom: 10px;
    }
    h3{
      line-height: 40px;
      text-align: center;
      font-size: 26px
    }  
  }
</style>
 


// WEBPACK FOOTER //
// src/components/mobile/Hdsq.vue